import { List } from 'antd';
import React, { useMemo } from 'react';
import LearningItem from '../learningItem';
import PropTypes from 'prop-types';
import { getString } from '@nackle/intl-tools';
import classNames from 'classnames';
import './styles.less';
import useIsMobile from '../../../hooks/useIsMobile';

const localeMap = {
    emptyText: {
        course: 'courseList.empty',
        curriculum: 'curriculumList.empty',
    }
};

const LearningList = ( { displayType, data, learningType, isLoading, className } ) => {

    const isMobile = useIsMobile( 900 );

    const overrideDisplayType = useMemo( () => {
        if ( isMobile ) {
            return 'card';
        }
        return displayType;
    }, [ isMobile, displayType ] );

    return isMobile || [ 'list', 'search' ].includes( displayType ) ? <List
            grid={ {
                gutter: [ 40, 30 ],
                column: 1
            } }
            dataSource={ data }
            className={ classNames( 'learning-list', `learning-list-${ overrideDisplayType }`, className ) }
            locale={ { emptyText: getString( localeMap.emptyText[ learningType ] ) } }
            renderItem={ ( item ) => (
                <List.Item
                    key={ item.id }>
                    <LearningItem
                        learningObject={ item }
                        isLoading={ isLoading }
                        displayType={ overrideDisplayType }
                        learningType={ learningType }
                    />
                </List.Item>
            ) }
        /> : <List
            grid={ {
                gutter: [ 40, 30 ],
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 4,
            } }
            dataSource={ data }
            className={ classNames( 'learning-list', `learning-list-${ overrideDisplayType }`, className ) }
            locale={ { emptyText: getString( localeMap.emptyText[ learningType ] ) } }
            renderItem={ ( item ) => (
                <List.Item
                    key={ item.id }>
                    <LearningItem
                        learningObject={ item }
                        isLoading={ isLoading }
                        displayType={ overrideDisplayType }
                        learningType={ learningType }
                    />
                </List.Item>
            ) }
        />;

};

LearningList.propTypes = {
    learningType: PropTypes.oneOf( [ 'course', 'curriculum', 'resource' ] ),
    displayType: PropTypes.oneOf( [ 'card', 'list', 'search' ] ).isRequired,
    data: PropTypes.arrayOf( PropTypes.object ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

LearningList.defaultProps = {
    className: '',
};

export default LearningList;